export const dateFormats = {
  day: "MM/DD/YYYY",
  dayWithHours: "MM/DD/YYYY HH:mm",
} as const;
